<template>
  <div>
    <template v-if="usar_tela_descanso">
      <v-img
        v-if="!tela_descanso_ativa"
        width="100vw"
        height="100vh"
        src="@/assets/capa_padrao.png"
      />
      <v-img
        v-else
        contain
        width="100vw"
        height="100vh"
        :src="tela_descanso_ativa.url_midia"
      />
    </template>
    <template v-else>
      <section
        class="wrapper"
        :style="{
          'background-color': configMosaico?.dscCorBackground,
          'background-image': `url(${configMosaico?.urlImgBackground})`,
          'background-size': 'cover',
        }"
      >
        <v-container class="mosaico-container mb-0">
          <v-icon v-if="isMosaicoLoading" class="mr-2 rotate loading-wrapper" x-large
            >mdi-loading</v-icon
          >
          <MosaicoGaleria
            v-if="!isMosaicoLoading && tipoMosaico === 'G'"
            :colaboracoes="colaboracoes"
            :cards-config="configCard"
            :flg-exibir-uf="flg_exibir_uf"
            @onSelectColaboracao="selectColab"
            :producao="producao"
          >
          </MosaicoGaleria>
          <MosaicoColuna
            v-if="!isMosaicoLoading && tipoMosaico === 'C'"
            :colaboracoes="colaboracoes"
            :cards-config="configCard"
            :flg-exibir-uf="flg_exibir_uf"
            :producao="producao"
            @onSelectColaboracao="selectColab"
          >
          </MosaicoColuna>
        </v-container>
        <div
          class="blur-wrapper"
          :style="isCardMosaicoVisible ? 'display: block' : 'display:none'"
          v-on:click="close($event)"
        >
          <div v-if="colabSelected" class="expanded-card-wrapper mx-auto my-5">
            <CardMosaicoGaleria
              :key="colabSelected ? colabSelected.id_colaboracao : ''"
              :content="colabSelected"
              :fullscreen="isCardMosaicoVisible"
              @played="getPlayerRef"
              :flg-exibir-uf="flg_exibir_uf"
              :card-config="configCard"
              :producao="producao"
            >
            </CardMosaicoGaleria>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import CardMosaicoGaleria from "@/components/Cards/CardMosaicoGaleria.vue";
import MosaicoGaleria from "@/components/Mosaico/MosaicoGaleria.vue";
import MosaicoColuna from "@/components/Mosaico/MosaicoColuna.vue";
import { apiClient } from "../services/api";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    MosaicoGaleria,
    MosaicoColuna,
    CardMosaicoGaleria,
  },
  data() {
    return {
      producao: {},
      isCardMosaicoVisible: false,
      selectedContent: {},
      colaboracoes: {},
      isMosaicoLoading: false,
      colabSelected: null,
      playerRef: undefined,
      configCard: {},
      usar_tela_descanso: false,
      flg_exibir_uf: true,
    };
  },
  computed: {
    ...mapGetters({
      tela_descanso_ativa: "telas_descanso/getTelaDescansoAtiva",
      tipoMosaico: "mosaico/getOrientacaoSelecionada",
      configMosaico: "mosaico/getConfigSelecionada",
    }),
    cod_producao() {
      return (
        JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) ||
        parseInt(this.$route.query.cod_producao) ||
        null
      );
    },
  },
  async beforeMount() {
    if (!this.$store.state.users.isAuthenticated) {
      apiClient.interceptors.request.use(
        (config) => {
          const token = this.$route.query.token || null;

          if (token) {
            config.headers["x-access-token"] = token;
          }
          return config;
        },
        (error) => {
          console.error(error);
          return Promise.reject(error);
        }
      );
    }

    setInterval(async () => {
      await this.getProducaoData();
    }, 3000);
    if (
      JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) == null &&
      this.$route.query.cod_producao == null
    ) {
      this.$router.push({ name: "login" });
      return;
    }
    this.isMosaicoLoading = true;
    this.configCard = this.configMosaico
      ? {
          dscCorCard: this.configMosaico?.dscCorCard,
          dscCorFonte: this.configMosaico?.dscCorFonte,
        }
      : null;

    this.fetchMosaicoData().then(() => {
      this.isMosaicoLoading = false;
    });
    this.getFlgUsarTelaDescanso();
    this.getTelaDescansoAtiva();
    this.getPreferenciasMosaico({ cod_producao: this.cod_producao });

    setInterval(() => {
      this.fetchMosaicoData();
      this.getTelaDescansoAtiva();
      this.getFlgUsarTelaDescanso();
      this.getPreferenciasMosaico({ cod_producao: this.cod_producao });
    }, 5000);
  },
  watch: {
    configMosaico: function (newVal) {
      this.configCard = newVal
        ? { dscCorCard: newVal?.dscCorCard, dscCorFonte: newVal?.dscCorFonte }
        : null;
    },
  },
  methods: {
    ...mapActions({
      fetchTelaDescansoAtiva: "telas_descanso/getTelaDescansoAtiva",
      getPreferenciasMosaico: "mosaico/getPreferenciasMosaico",
    }),
    async getProducaoData() {
      await apiClient.get(`listarDadosProducao/${this.cod_producao}`).then((response) => {
        this.producao = response.data.producao;
        this.cod_producao = response.data.producao.cod_producao;
      });
    },
    async fetchMosaicoData() {
      const cod_producao =
        JSON.parse(localStorage.getItem("@socialcam/selected_option_production")) ||
        parseInt(this.$route.query.cod_producao) ||
        null;
      const first_column_response = await apiClient.get(
        `/ColaboracoesModeradaXml/${cod_producao}/1`
      );
      const second_column_response = await apiClient.get(
        `/ColaboracoesModeradaXml/${cod_producao}/2`
      );
      const third_column_response = await apiClient.get(
        `/ColaboracoesModeradaXml/${cod_producao}/3`
      );

      const colaboracoes_moderadas_col1 = this.removerColaboracoesDoTwitterDoObjeto(
        first_column_response.data.colaboracoes_moderadas
      );
      const colaboracoes_moderadas_col2 = this.removerColaboracoesDoTwitterDoObjeto(
        second_column_response.data.colaboracoes_moderadas
      );
      const colaboracoes_moderadas_col3 = this.removerColaboracoesDoTwitterDoObjeto(
        third_column_response.data.colaboracoes_moderadas
      );

      const updatedColabs = {
        colunaExibicao1: colaboracoes_moderadas_col1,
        colunaExibicao2: colaboracoes_moderadas_col2,
        colunaExibicao3: colaboracoes_moderadas_col3,
      };

      this.colaboracoes = { ...updatedColabs };
    },
    removerColaboracoesDoTwitterDoObjeto(array) {
      return array.filter((value) => value.flg_colaboracao_lida === 0);
    },
    async getFlgUsarTelaDescanso() {
      try {
        const response = await apiClient.get(`/listarDadosProducao/${this.cod_producao}`);

        if (response.status === 200) {
          const producao = response.data.producao;
          const usarTelaDescanso = producao.settings?.mosaico?.usar_tela_descanso ?? false;
          const exibirUf = producao.settings?.mosaico?.exibir_uf ?? true;
          localStorage.setItem("@socialcam/usar_tela_descanso", usarTelaDescanso);
          localStorage.setItem("@socialcam/exibir_uf_mosaico", exibirUf);
          this.usar_tela_descanso = usarTelaDescanso;
          this.flg_exibir_uf = exibirUf;
        }
      } catch (error) {
        return this.$toast.error(error.response.data.msg);
      }
    },
    async getTelaDescansoAtiva() {
      await this.fetchTelaDescansoAtiva({ cod_producao: this.cod_producao });
    },
    colaboracaoContemMidia(content) {
      return content.url_midia_thumbnail || content.url_midia_colaboracao;
    },
    changeVisible() {
      this.isCardMosaicoVisible = !this.isCardMosaicoVisible;
    },
    selectColab({ coluna, index }) {
      this.colabSelected = this.colaboracoes[`colunaExibicao${coluna}`][index];
      this.changeVisible();
    },
    getPlayerRef(ref) {
      this.playerRef = ref;
    },
    close(event) {
      const targetClass = event.target.className.toLowerCase();
      if (
        targetClass.includes("blur-wrapper") ||
        targetClass.includes("expanded-card-wrapper")
      ) {
        if (this.playerRef) {
          this.playerRef.pause();
          this.playerRef = undefined;
        }
        this.changeVisible();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  max-height: 100%;
  height: 100vh;
  margin: auto;
}

.loading-wrapper {
  position: fixed;
  top: 50%;
  right: 50%;
}

.mosaico-container {
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 25px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.rotate {
  animation: spin 2s linear infinite;
}

.blur-wrapper {
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 1;
}

.expanded-card-wrapper {
  height: 95%;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background-color: transparent;
  box-shadow: none !important;

  @media screen and (max-width: 600px) {
    width: 90%;
  }
}
</style>
